// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* The Invite editors dialog's own parts. The title, field, buttons and footer
   are ConfirmDialog's (ConfirmDialog.module.css), as PromptDialog's are. */

.SlnXU9R3nrHngBqUSNpI {
    width: min(440px, 100%);
}

.jtQExo6XGVsIaCkZ1cb7 {
    margin: 0 0 14px;
    font-size: var(--curio-font-size-md);
    color: var(--curio-text-secondary);
    line-height: 1.5;
}

.rqZemyZfhHpbTCKCyAiY {
    display: flex;
    gap: 8px;
}

.rqZemyZfhHpbTCKCyAiY input {
    flex: 1;
    min-width: 0;
}

.W6lyMlY1ADy4X4Y2ZiAt {
    margin: 8px 0 0;
    font-size: var(--curio-font-size-md);
    color: var(--curio-danger-text);
}

.KN0C1A78iSigobaHxD2o {
    margin: 20px 0 6px;
}

.rEIyiyMKq2_O0eQWoo0o {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.ePf36Vj1fJkgRGxWFqpH {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 8px;
    border: 1px solid var(--curio-border-strong);
    border-radius: var(--curio-radius-md);
    background: var(--curio-card-bg);
    font-size: var(--curio-font-size-md);
}

.fn9O7BcVhAP8oDTntcSg {
    color: var(--curio-text-primary);
    font-weight: 600;
}

.P2mix3KdZGyYv1tkLspN {
    color: var(--curio-text-muted);
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.UaxRPvQ9_CM6T5V88sPr {
    width: 28px;
    height: 28px;
    border: none;
    border-radius: var(--curio-radius-md);
    background: transparent;
    color: var(--curio-text-secondary);
    cursor: pointer;
}

.UaxRPvQ9_CM6T5V88sPr:hover:not(:disabled) {
    background: var(--curio-page-bg);
    color: var(--curio-danger-text);
}

.UaxRPvQ9_CM6T5V88sPr:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.EVEHPh6yvq4YeG8GUzZw {
    margin: 0;
    font-size: var(--curio-font-size-md);
    color: var(--curio-text-muted);
}
`, "",{"version":3,"sources":["webpack://./src/components/collab/InviteEditorsDialog.module.css"],"names":[],"mappings":"AAAA;2EAC2E;;AAE3E;IACI,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,oCAAoC;IACpC,kCAAkC;IAClC,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,oCAAoC;IACpC,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,4CAA4C;IAC5C,qCAAqC;IACrC,gCAAgC;IAChC,oCAAoC;AACxC;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,OAAO;IACP,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,qCAAqC;IACrC,uBAAuB;IACvB,kCAAkC;IAClC,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,+BAA+B;AACnC;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,oCAAoC;IACpC,8BAA8B;AAClC","sourcesContent":["/* The Invite editors dialog's own parts. The title, field, buttons and footer\n   are ConfirmDialog's (ConfirmDialog.module.css), as PromptDialog's are. */\n\n.dialog {\n    width: min(440px, 100%);\n}\n\n.intro {\n    margin: 0 0 14px;\n    font-size: var(--curio-font-size-md);\n    color: var(--curio-text-secondary);\n    line-height: 1.5;\n}\n\n.addRow {\n    display: flex;\n    gap: 8px;\n}\n\n.addRow input {\n    flex: 1;\n    min-width: 0;\n}\n\n.error {\n    margin: 8px 0 0;\n    font-size: var(--curio-font-size-md);\n    color: var(--curio-danger-text);\n}\n\n.listTitle {\n    margin: 20px 0 6px;\n}\n\n.list {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.row {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 6px 8px;\n    border: 1px solid var(--curio-border-strong);\n    border-radius: var(--curio-radius-md);\n    background: var(--curio-card-bg);\n    font-size: var(--curio-font-size-md);\n}\n\n.name {\n    color: var(--curio-text-primary);\n    font-weight: 600;\n}\n\n.username {\n    color: var(--curio-text-muted);\n    flex: 1;\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.remove {\n    width: 28px;\n    height: 28px;\n    border: none;\n    border-radius: var(--curio-radius-md);\n    background: transparent;\n    color: var(--curio-text-secondary);\n    cursor: pointer;\n}\n\n.remove:hover:not(:disabled) {\n    background: var(--curio-page-bg);\n    color: var(--curio-danger-text);\n}\n\n.remove:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.empty {\n    margin: 0;\n    font-size: var(--curio-font-size-md);\n    color: var(--curio-text-muted);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dialog": `SlnXU9R3nrHngBqUSNpI`,
	"intro": `jtQExo6XGVsIaCkZ1cb7`,
	"addRow": `rqZemyZfhHpbTCKCyAiY`,
	"error": `W6lyMlY1ADy4X4Y2ZiAt`,
	"listTitle": `KN0C1A78iSigobaHxD2o`,
	"list": `rEIyiyMKq2_O0eQWoo0o`,
	"row": `ePf36Vj1fJkgRGxWFqpH`,
	"name": `fn9O7BcVhAP8oDTntcSg`,
	"username": `P2mix3KdZGyYv1tkLspN`,
	"remove": `UaxRPvQ9_CM6T5V88sPr`,
	"empty": `EVEHPh6yvq4YeG8GUzZw`
};
export default ___CSS_LOADER_EXPORT___;
